<div id="layout" class="theme-cyan">

  <div class="authentication">

    <div class="container d-flex flex-column">

      <div class="row align-items-center justify-content-center no-gutters min-vh-100">

        <div class="col-12 col-md-7 col-lg-5 col-xl-4 py-md-11">

          <div class="card border-0 shadow-sm">
            <div class="card-body">
              <!-- Heading -->
              <h3 class="text-center">Password Reset</h3>

              <!-- Text -->
              <p class="text-center mb-6">Please enter your email address below to receive instructions for resetting
                password.</p>

              <!-- Form -->
              <form class="mb-4 mt-5">
                <!-- Email -->
                <div class="input-group mb-2">
                  <input type="email" class="form-control form-control-lg" placeholder="Enter your email">
                </div>

                <!-- Submit -->
                <div class="text-center mt-5">
                  <a [routerLink]="['/sign-in']" href="javascript:void(0)" class="btn btn-lg btn-primary" title="">Send
                    Reset link</a>
                </div>
              </form>

              <!-- Text -->
              <p class="text-center mb-0">Already have an account? <a class="link" [routerLink]="['/sign-in']"
                  href="javascript:void(0)">Sign in</a>.</p>
            </div>
          </div>

        </div>

        <div class="signin-img d-none d-lg-block text-center">
          <img src="assets/images/signin-img-cyan.svg" alt="Sign In Image" />
        </div>

      </div> <!-- / .row -->

    </div>

  </div>

</div>
